/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { assignCommitmentsToActivity } from '../fn/profile-commitment/assign-commitments-to-activity';
import { AssignCommitmentsToActivity$Params } from '../fn/profile-commitment/assign-commitments-to-activity';
import { createCommitmentForProfile } from '../fn/profile-commitment/create-commitment-for-profile';
import { CreateCommitmentForProfile$Params } from '../fn/profile-commitment/create-commitment-for-profile';
import { deleteCommitmentForProfile } from '../fn/profile-commitment/delete-commitment-for-profile';
import { DeleteCommitmentForProfile$Params } from '../fn/profile-commitment/delete-commitment-for-profile';
import { listCommitmentsForProfile } from '../fn/profile-commitment/list-commitments-for-profile';
import { ListCommitmentsForProfile$Params } from '../fn/profile-commitment/list-commitments-for-profile';
import { ProfileCommitmentResponse } from '../models/profile-commitment-response';
import { ProfileCommitmentsWithOrder } from '../models/profile-commitments-with-order';
import { updateCommitmentForProfile } from '../fn/profile-commitment/update-commitment-for-profile';
import { UpdateCommitmentForProfile$Params } from '../fn/profile-commitment/update-commitment-for-profile';
import { updateCommitmentsOrderForProfile } from '../fn/profile-commitment/update-commitments-order-for-profile';
import { UpdateCommitmentsOrderForProfile$Params } from '../fn/profile-commitment/update-commitments-order-for-profile';

@Injectable({ providedIn: 'root' })
export class ProfileCommitmentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `assignCommitmentsToActivity()` */
  static readonly AssignCommitmentsToActivityPath = '/rest/profile/commitment/assign-commitments-to-activity';

  /**
   * Assign multiple commitments to activity - previously added commitments are removed. Cannot assign activity to commitments which profile is not organizing activity.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `assignCommitmentsToActivity()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assignCommitmentsToActivity$Response(params: AssignCommitmentsToActivity$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return assignCommitmentsToActivity(this.http, this.rootUrl, params, context);
  }

  /**
   * Assign multiple commitments to activity - previously added commitments are removed. Cannot assign activity to commitments which profile is not organizing activity.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `assignCommitmentsToActivity$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  assignCommitmentsToActivity(params: AssignCommitmentsToActivity$Params, context?: HttpContext): Observable<void> {
    return this.assignCommitmentsToActivity$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `listCommitmentsForProfile()` */
  static readonly ListCommitmentsForProfilePath = '/rest/profile/{id}/commitment';

  /**
   * List profile commitments for profile.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listCommitmentsForProfile()` instead.
   *
   * This method doesn't expect any request body.
   */
  listCommitmentsForProfile$Response(params: ListCommitmentsForProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ProfileCommitmentResponse>>> {
    return listCommitmentsForProfile(this.http, this.rootUrl, params, context);
  }

  /**
   * List profile commitments for profile.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listCommitmentsForProfile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listCommitmentsForProfile(params: ListCommitmentsForProfile$Params, context?: HttpContext): Observable<Array<ProfileCommitmentResponse>> {
    return this.listCommitmentsForProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ProfileCommitmentResponse>>): Array<ProfileCommitmentResponse> => r.body)
    );
  }

  /** Path part for operation `createCommitmentForProfile()` */
  static readonly CreateCommitmentForProfilePath = '/rest/profile/{id}/commitment';

  /**
   * Create new profile commitment for profile with impacts and assigned activities (cannot assign activity to commitment if profile is not organizing activity).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createCommitmentForProfile()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCommitmentForProfile$Response(params: CreateCommitmentForProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileCommitmentResponse>> {
    return createCommitmentForProfile(this.http, this.rootUrl, params, context);
  }

  /**
   * Create new profile commitment for profile with impacts and assigned activities (cannot assign activity to commitment if profile is not organizing activity).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createCommitmentForProfile$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createCommitmentForProfile(params: CreateCommitmentForProfile$Params, context?: HttpContext): Observable<ProfileCommitmentResponse> {
    return this.createCommitmentForProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileCommitmentResponse>): ProfileCommitmentResponse => r.body)
    );
  }

  /** Path part for operation `updateCommitmentsOrderForProfile()` */
  static readonly UpdateCommitmentsOrderForProfilePath = '/rest/profile/{id}/commitment/order';

  /**
   * Order commitments for profile, with commitments IDs and order. Higher orderId is sorted first.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCommitmentsOrderForProfile()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCommitmentsOrderForProfile$Response(params: UpdateCommitmentsOrderForProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileCommitmentsWithOrder>> {
    return updateCommitmentsOrderForProfile(this.http, this.rootUrl, params, context);
  }

  /**
   * Order commitments for profile, with commitments IDs and order. Higher orderId is sorted first.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCommitmentsOrderForProfile$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCommitmentsOrderForProfile(params: UpdateCommitmentsOrderForProfile$Params, context?: HttpContext): Observable<ProfileCommitmentsWithOrder> {
    return this.updateCommitmentsOrderForProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileCommitmentsWithOrder>): ProfileCommitmentsWithOrder => r.body)
    );
  }

  /** Path part for operation `updateCommitmentForProfile()` */
  static readonly UpdateCommitmentForProfilePath = '/rest/profile/{profileId}/commitment/{id}';

  /**
   * Update existing profile commitment for profile with impacts and assigned activities (cannot assign activity to commitment if profile is not organizing activity).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCommitmentForProfile()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCommitmentForProfile$Response(params: UpdateCommitmentForProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<ProfileCommitmentResponse>> {
    return updateCommitmentForProfile(this.http, this.rootUrl, params, context);
  }

  /**
   * Update existing profile commitment for profile with impacts and assigned activities (cannot assign activity to commitment if profile is not organizing activity).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCommitmentForProfile$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateCommitmentForProfile(params: UpdateCommitmentForProfile$Params, context?: HttpContext): Observable<ProfileCommitmentResponse> {
    return this.updateCommitmentForProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<ProfileCommitmentResponse>): ProfileCommitmentResponse => r.body)
    );
  }

  /** Path part for operation `deleteCommitmentForProfile()` */
  static readonly DeleteCommitmentForProfilePath = '/rest/profile/{profileId}/commitment/{id}';

  /**
   * Delete existing profile commitment for profile (delete also impacts and assigned activities).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteCommitmentForProfile()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCommitmentForProfile$Response(params: DeleteCommitmentForProfile$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return deleteCommitmentForProfile(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete existing profile commitment for profile (delete also impacts and assigned activities).
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteCommitmentForProfile$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteCommitmentForProfile(params: DeleteCommitmentForProfile$Params, context?: HttpContext): Observable<void> {
    return this.deleteCommitmentForProfile$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
